export class ApiError extends Error {
  readonly code: string;
  readonly status: number;
  readonly issues?: unknown[];
  /**
   * The full parsed error body. Routes that return structured context beyond
   * `error`/`issues` (e.g. publish's `conflicts` list) read it from here.
   */
  readonly details?: Record<string, unknown>;

  constructor(
    code: string,
    status: number,
    issues?: unknown[],
    details?: Record<string, unknown>,
  ) {
    super(`${code} (${status})`);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
    this.issues = issues;
    this.details = details;
  }
}

export async function apiFetch<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    credentials: 'same-origin',
    headers: { 'content-type': 'application/json', ...(init?.headers ?? {}) },
    ...init,
  });
  if (res.ok) {
    if (res.status === 204) return undefined as T;
    return (await res.json()) as T;
  }
  let body: { error?: string; issues?: unknown[] } = {};
  try {
    body = await res.json();
  } catch {
    // non-JSON body
  }
  throw new ApiError(
    body.error ?? 'unknown',
    res.status,
    body.issues,
    body as Record<string, unknown>,
  );
}
